import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { utils, comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage, usePopup } from "@/comn/hooks";
import { APIS, SF_XTRN_USR_INFO, URLS } from "@/tra/tancis/ptli/usr/xtrnusr/services/PtliXtrnUsrService";
import { values } from "lodash";

/*
 * External User Registration
 * !== 외부 사용자 등록 ==!
 */
export const PTLI0922002S = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0001", "auth_ptli0015", "auth_ptlianyADM"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { openPopup } = usePopup();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0021" },
            { area: "comnCd", comnCd: "PTL0001" },
            { area: "cntyCd" },
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // User Information !== 외부 사용자 정보 ==!
        xtrnUsrInfo: useForm({
            defaultSchema: SF_XTRN_USR_INFO,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Create External User Information !== 외부 사용자 정보 등록 ==!
        createXtrnUsrInfo: useFetch({
            api: (data: any) => APIS.createXtrnUsrInfo(data),
            enabled: false,
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00058" }); // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
                navigate(`${URLS.ptli0922001q}`);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00018" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),
        getTinNoLst: useFetch({
            api: () => {
                return APIS.getPayerTinNoLst(xtrnUsrIdntfNo, "A");
            },
            // enabled: !!coTin,
            // key: [coTin],
            onSuccess: (data) => {
                const tinNoList = data.tinNoList.content;

                if (tinNoList.length == 1) {
                    const tinNoInfo = tinNoList[0];
                    form.xtrnUsrInfo.setValue("xtrnUsrIdntfNo", tinNoInfo.tinNo);
                    form.xtrnUsrInfo.setValue("usrNm", tinNoInfo.coNm);
                    form.xtrnUsrInfo.setValue("usrMoblNo", tinNoInfo.rprsTelno);
                    form.xtrnUsrInfo.setValue("rsdtAddr", tinNoInfo.coAddr);
                    form.xtrnUsrInfo.setValue("usrEmlAddr", tinNoInfo.rprsEml);
                    handler.checkUsrTin();
                } else {
                    toast.showToast({ type: "error", content: "msg.clr.00004" });

                    form.xtrnUsrInfo.setValue("usrNm", null);
                    form.xtrnUsrInfo.setValue("aplcCntyCd", null);
                    form.xtrnUsrInfo.setValue("usrMoblNo", null);
                    form.xtrnUsrInfo.setValue("rsdtAddr", null);
                    form.xtrnUsrInfo.setValue("usrEmlAddr", null);
                }
            },
        }),
        // Ckeck the External User duplicate !== 외부 사용자 중복 체크 ==!
        getXtrnDuplCheck: useFetch({
            api: (data: any) => APIS.getXtrnDuplCheck(data),
            enabled: false,
            onSuccess: (data) => {
                form.xtrnUsrInfo.clearErrors("xtrnUsrIdntfNo");

                const impExpInfo = data.xtrnUsrInfo.content;

                if (comnUtils.isEmpty(impExpInfo) || comnUtils.isUndefined(impExpInfo)) {
                    form.xtrnUsrInfo.setValue("xtrnUsrRgsrYn", "N");
                } else if (impExpInfo.impExpYn == "Y") {
                    form.xtrnUsrInfo.setError("xtrnUsrIdntfNo", {
                        message: "msg.com.00107", // Already registered user. !== 이미 등록된 사용자입니다. ==!
                        type: "error",
                    });

                    form.xtrnUsrInfo.setValue("usrNm", null);
                    form.xtrnUsrInfo.setValue("aplcCntyCd", null);
                    form.xtrnUsrInfo.setValue("usrMoblNo", null);
                    form.xtrnUsrInfo.setValue("rsdtAddr", null);
                    form.xtrnUsrInfo.setValue("usrEmlAddr", null);

                    form.xtrnUsrInfo.setValue("xtrnUsrRgsrYn", "Y");
                } else {
                    modal.openModal({ content: "msg.ptl.00817" }); // There is registered user information, so existing user information is retrieved. A temporary password will be sent when registering as a member. !== 등록된 사용자정보가 존재하여 기존 사용자 정보를 불러옵니다. 회원등록시 임시 비밀번호가 발송됩니다. ==!

                    form.xtrnUsrInfo.setValue("usrNm", impExpInfo.usrNm);
                    form.xtrnUsrInfo.setValue("frgnrYn", impExpInfo.frgnrYn);
                    form.xtrnUsrInfo.setValue("aplcCntyCd", impExpInfo.aplcCntyCd);
                    form.xtrnUsrInfo.setValue("usrMoblNo", impExpInfo.usrMoblNo);
                    form.xtrnUsrInfo.setValue("usrEmlAddr", impExpInfo.usrEmlAddr);
                    form.xtrnUsrInfo.setValue("rsdtAddr", impExpInfo.rsdtAddr);

                    form.xtrnUsrInfo.setValue("xtrnUsrRgsrYn", "Y");
                }
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const render = {};

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        onXtrnSaveBtnClick: () => {
            if (
                comnUtils.isEmpty(form.xtrnUsrInfo.getValue("cstmOfcrNo")) &&
                form.xtrnUsrInfo.getValue("actnCtgrCd") == "1"
            ) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            if (!comnUtils.isEmpty(form.xtrnUsrInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            // Saving External User Information !== 외부 사용자 정보 저장 ==!
            form.xtrnUsrInfo.handleSubmit(
                () => {
                    const data = form.xtrnUsrInfo.getValues();

                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.createXtrnUsrInfo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
        setCoTinChange: () => {
            form.xtrnUsrInfo.setError("xtrnUsrIdntfNo", {
                message: "msg.ptl.00755", // Please check your TIN. !== TIN을 조회해주세요. ==!
                type: "error",
            });
        },
        checkUsrTin: () => {
            if (xtrnUsrIdntfNo) {
                fetch.getXtrnDuplCheck.fetch(xtrnUsrIdntfNo);
            } else {
                form.xtrnUsrInfo.clearErrors("xtrnUsrIdntfNo");
            }
        },
    };

    useEffect(() => {}, []);

    const xtrnUsrIdntfNo = form.xtrnUsrInfo.watch("xtrnUsrIdntfNo");
    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control
                                    {...form.xtrnUsrInfo.schema.xtrnUsrIdntfNo}
                                    rightButton={{
                                        icon: "search",
                                        onClick: () => {
                                            if (comnUtils.isEmpty(xtrnUsrIdntfNo)) {
                                                form.xtrnUsrInfo.setError("xtrnUsrIdntfNo", {
                                                    message: "msg.com.00005", // Mandatory fields !== 필수 입력 필드 ==!
                                                    type: "error",
                                                });
                                            } else {
                                                form.xtrnUsrInfo.clearErrors("xtrnUsrIdntfNo");
                                                fetch.getTinNoLst.fetch(xtrnUsrIdntfNo);
                                            }
                                        },
                                    }}
                                />
                                <Group.Control {...form.xtrnUsrInfo.schema.usrNm}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.xtrnUsrInfo.schema.frgnrYn}></Group.Control>
                                <Group.Control {...form.xtrnUsrInfo.schema.aplcCntyCd}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.xtrnUsrInfo.schema.usrMoblNo}></Group.Control>
                                <Group.Control {...form.xtrnUsrInfo.schema.usrStatCd}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.xtrnUsrInfo.schema.usrEmlAddr}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.xtrnUsrInfo.schema.rsdtAddr}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            </form>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.ptli0922001q);
                        }}
                    ></Button>
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.onXtrnSaveBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
